function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 8h6v1H5z"
});

const SvgNoChangeIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  fill: "current",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoChangeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-change-icon.ea6a30aa.svg";
export { ForwardRef as ReactComponent };